import _ from 'lodash';
import log from './log';

import { GOODIES } from '../constants';

function getNewGoodyOfPetType(collectedGoodies, petType) {

	// Get array of all new goodies that we can get for this pet type
	const newGoodiesForPetType = _.filter(GOODIES, (goody) => {
		const isForThisPetType = goody.forPetType === petType;
		const isNotCollected = !_.includes(collectedGoodies, goody.id);

		return isForThisPetType && isNotCollected;
	});

	log('getNewGoodyOfPetType -> newGoodiesForPetType: ', newGoodiesForPetType);

	// Return a random new goody.
	return newGoodiesForPetType[_.random(newGoodiesForPetType.length - 1)];
}

export default getNewGoodyOfPetType;



// WEBPACK FOOTER //
// ./src/utils/getNewGoodyOfPetType.js